export default {
	get(url) {
		return window.Vue.$http.get(url)
	},
	getUserStatus() {
		return window.Vue.$http.get('list/userstatus')
	},
	getRoleList() {
		return window.Vue.$http.get('list/role')
	},
	getBonuslinkPointTypeList() {
		return window.Vue.$http.get('list/bonuslinkpointtype')
	},
	getById(url) {
		return window.Vue.$http.get(url)
	},

	getPayoutCountryList() {
		return window.Vue.$http.get('list/payoutCountry')
	},

	getNonHRCCountryList() {
		return window.Vue.$http.get('list/nonhrc')
	},
	getCountry() {
		return window.Vue.$http.get('list/country')
	},
	getBonuslinkPointTypeList() {
		return window.Vue.$http.get('list/countrymal')
	},
	getCountryPayoutMode(url) {
		return window.Vue.$http.get(url)
	},
	getPayingGroupCode(url) {
		return window.Vue.$http.get(url)
	},
	getCategory() {
		return window.Vue.$http.get('list/category')
	},
	getChargeModeList() {
		return window.Vue.$http.get('list/chargemode')
	},
	getTrxLimit(url) {
		return window.Vue.$http.get(url)
	},
	getEcddCheck(url) {
		return window.Vue.$http.get(url)
	},
	getEcddTypeList() {
		return window.Vue.$http.get('list/ecddtype')
	},
	getCountryForExRateList() {
		return window.Vue.$http.get('list/country/excrate')
	},

	getFpx(url) {
		return window.Vue.$http.get(url)
	},
	getMoneygramConfig(url) {
		return window.Vue.$http.get(url)
	},
	getLoyality(url) {
		return window.Vue.$http.get(url)
	},
	getBroadcastMsg(url) {
		return window.Vue.$http.get(url)
	},
	getMobileNotiMsg(url) {
		return window.Vue.$http.get(url)
	},
	getSmsConfig(url) {
		return window.Vue.$http.get(url)
	},
	getEmailConfig(url) {
		return window.Vue.$http.get(url)
	},
	getBroadcastEmailConfig(url) {
		return window.Vue.$http.get(url)
	},
	getBroadcastSmsConfig(url) {
		return window.Vue.$http.get(url)
	},
	getImageTypesList() {
		return window.Vue.$http.get('list/mobileImageTypes')
	},
	getPlatformsList() {
		return window.Vue.$http.get('list/platforms')
	},
	getAndroidBanners(url) {
		return window.Vue.$http.get(url)
	},
	getIosBanners(url) {
		return window.Vue.$http.get(url)
	},
	getWebBanners(url) {
		return window.Vue.$http.get(url)
	},

	getCompareType() {
		return window.Vue.$http.get('list/comparetype')
	},
	getSecretQuestion() {
		return window.Vue.$http.get('list/secretquestion')
	},
	getStateMalaysia() {
		return window.Vue.$http.get('list/statemala')
	},
	getNationality() {
		return window.Vue.$http.get('list/nationality')
	},
	getGender() {
		return window.Vue.$http.get('list/gender')
	},
	getOccupation() {
		return window.Vue.$http.get('list/occupation')
	},
	getResidentalStaus() {
		return window.Vue.$http.get('list/residentalstatus')
	},
	getQuesHearAboutUs() {
		return window.Vue.$http.get('list/queshearaboutus')
	},
	getQuesPayment() {
		return window.Vue.$http.get('list/quespayment')
	},
	getQuesSendingInterval() {
		return window.Vue.$http.get('list/quesendinterval')
	},
	getQuesPaymentPurpose() {
		return window.Vue.$http.get('list/quespaymentpurpose')

		return window.Vue.$http.get('list/country/excrate')
	},
	getMalaysianState() {
		return window.Vue.$http.get('list/malaysianstates')
	},
	getCompanyStatus() {
		return window.Vue.$http.get('list/companystatus')
	},
	getBOCountryList() {
		return window.Vue.$http.get('list/listbocountry')
	},
	getList(url) {
		return window.Vue.$http.get(url)
	},
	getCollectionMode() {
		return window.Vue.$http.get('list/listPaymentMethod')
	},
	getRemittanceTransactionStatus() {
		return window.Vue.$http.get('list/listremittancetransactionstatus')
	},
	checkEmailValidation(url) {
		return window.Vue.$http.get(url)
	},
	getActiveMirsCountry() {
		return window.Vue.$http.get('list/mirscountry')
	},
	getCountryWithPayout() {
		return window.Vue.$http.get('list/countrywithpayout')
	},
	getMoneygramCountry() {
		return window.Vue.$http.get('list/moneygramcountry')
	},
	getRelationship(payoutModeId, countryId) {
		return window.Vue.$http.get('list/relationship/' + payoutModeId + '/' + countryId);
	},
	getRefundBank() {
		return window.Vue.$http.get('list/refundbank')
	},
	getTransactionDetailByRefNo(refno) {
		return window.Vue.$http.get('list/transaction/detail/' + refno);
	},
	getFpxBank() {
		return window.Vue.$http.get('list/fpxbank')
	},
	mailValidate(user, code) {
		return window.Vue.$http.post("account/confirm/email", {
			UserId: user,
			Code: code
		});
	},
	getRegistrationInitComplete() {
		return window.Vue.$http.get('account/register/initcomplete')
	},
	getPassPhrase() {
		return window.Vue.$http.get("v2/account/passphrase/get")
	},
	getFeildValidate(countryid, payoutid) {
		return window.Vue.$http.post("recipient/validatefields", {
			PayoutId: payoutid,
			CountryId: countryid
		});
	},
	getFeildValidateByBeneficiary(payoutid, beneId) {
		return window.Vue.$http.get('recipient/validatefieldsbybeneficiary/' + payoutid + '/' + beneId);
	},
	getFeildValidateByWUBeneficiary(beneId) {
		return window.Vue.$http.get('recipient/validatefieldsbywubeneficiary/' + beneId);
	},

	getFeildValidateByVDBeneficiary(beneId) {
		return window.Vue.$http.get('recipient/validatefieldsbyvdbeneficiary/' + beneId);
	},

	getCurrentDateTime() {
		return window.Vue.$http.get('list/currentdatetime')
	},

	getStreetTypeByCountry(countryId) {
		return window.Vue.$http.get('list/streettype/' + countryId);
	},

	getOnBehalfList() {
		return window.Vue.$http.get("onbehalf/customer/list")
	},
	getAccountValidation(countryid, payoutid, bankid) {
		return window.Vue.$http.post("v2/recipient/accno/validation", {
			BankId: bankid,
			CountryId: countryid,
			PaymentModeId: payoutid
		});
	},

}
